module.exports = __webpack_public_path__ + "media/images/top/pap/common/img_point03-a56a7912d9d59676359e7a09d74e71f7.png";